import { Component } from '@angular/core';
import { ICellRenderer } from 'ag-grid-community';
import { MatIcon } from '@angular/material/icon';
@Component({
    selector: 'app-action-cell',
    template: `
    <span><mat-icon (click)="sendEmail()" title="Send email">picture_as_pdf</mat-icon></span>
  `,
    imports: [MatIcon]
})
export class CustomersGridActionRendererComponent
  implements ICellRenderer {
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  sendEmail() {
    this.params.context.componentParent.sendEmail(this.params.node.data);
  }

  refresh(): boolean {
    return false;
  }
}

